export default __webpack_public_path__ + "static/media/karl.e5e44399.png";